import React from 'react'
import OnVisible from 'react-on-visible'
import { Section, Image, IconCollection } from 'newComponents'
import stars from '../../images/stars.jpg'
import './styles.scss'

const TitleImageColumns = (props) => {
  const { data } = props
  const { primary, items } = data
  const { content, title, icons } = primary
  // content checks
  const titleHtml = title?.html
  const contentHtml = content?.html

  return (
    <OnVisible className="title-img-cols">
      <Section bgImage={stars}>
        {titleHtml && <div className="title-img-cols-title" dangerouslySetInnerHTML={{ __html: titleHtml }} />}
        {contentHtml && <div className="title-img-cols-content" dangerouslySetInnerHTML={{ __html: contentHtml }} />}
        <IconCollection icons={icons} />
        <div className="title-img-cols-grid">
          {items.map((item) => {
            const { column_content: colContent, column_title: colTitle } = item
            const colContentHtml = colContent?.html
            const colTitleHTml = colTitle?.html
            return (
              <div className="title-img-cols-column" key={colTitle.text}>
                {colTitleHTml && (
                  <div className="title-img-cols-column-title" dangerouslySetInnerHTML={{ __html: colTitleHTml }} />
                )}
                {colContentHtml && (
                  <div className="title-img-cols-column-content" dangerouslySetInnerHTML={{ __html: colContentHtml }} />
                )}
              </div>
            )
          })}
        </div>
      </Section>
    </OnVisible>
  )
}

export default TitleImageColumns
